import { areTaxesIncludedInPrice } from '@/app/common/config/configuration/configurationUtilsClient.ts';
import { getSearchParam } from '@/app/common/urlParametersUtils.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import getSearchParams from '@/app/components/search/common/getSearchParams.ts';
import { formatPrice } from '@/app/components/search/utils/formatting.ts';
import { getPercentage } from '../../../Card/utils/getPriceDetails';
import type { Localization } from '../../../../common/Localization';
import type { DealCard } from '../../../../utils/buildDealCards/dealCardTypes';

export const getPackageSavings = (dealCard: DealCard, localization: Localization) => {
  const packageDiscount = dealCard?.product?.rate?.packageDiscount;
  const { country, configValuesApp } = localization;
  const searchParams = getSearchParams();
  const searchMode = getSearchParam(searchParams, URLParameters.SEARCH_MODE);
  const taxesIncluded = areTaxesIncludedInPrice({ searchMode, country, configValuesApp });

  // Raw values from backend
  const taxes = dealCard?.product?.rate?.price?.taxesTotal || 0;
  const totalPrice = dealCard?.product?.rate?.price?.total?.price || 0;
  const strikethrough = dealCard?.product?.rate?.price?.total?.strikethrough || 0;
  const priceFO = packageDiscount?.totalPriceFo || 0;
  const priceHO = packageDiscount?.totalPriceHo || 0;

  // Calculate prices with taxes when included
  const priceHOWithTaxes = taxesIncluded ? priceHO + taxes : priceHO;
  const strikethroughWithTaxes = taxesIncluded ? strikethrough + taxes : strikethrough;

  // Calculate totals with rounding
  const totalPriceFOHO = Math.round(priceFO + priceHOWithTaxes);
  const basePriceFOHO = Math.round(priceFO + priceHO);

  // Calculate savings
  const savingsDifference = totalPriceFOHO - totalPrice;
  const totalSavings = Math.abs(Math.round(savingsDifference));
  const totalSavingsPercentage = getPercentage(savingsDifference, basePriceFOHO);

  return {
    totalSavings,
    totalSavingsPercentage,
    showStrikethroughPrice: totalPrice < strikethroughWithTaxes,
    totalSavingsFormatted: formatPrice({ price: savingsDifference, localization }),
    totalPriceFormatted: formatPrice({ price: totalPrice, localization }),
    totalPriceHOFormatted: formatPrice({ price: priceHOWithTaxes, localization }),
    totalPriceFOFormatted: formatPrice({ price: priceFO, localization }),
    totalStrikethroughPriceFormatted: formatPrice({ price: strikethroughWithTaxes, localization }),
    totalPriceFOHOFormatted: formatPrice({ price: totalPriceFOHO, localization }),
  };
};
